var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.dateBegin)?_c('Datepicker1',{attrs:{"dateInit":_vm.dateBegin,"eventName":_vm.evNameDtBegin,"monthEnable":false}}):_vm._e(),(_vm.dateBegin)?_c('PoiRegChart',{attrs:{"tags":_vm.tags,"dateBegin":_vm.dateBegin,"dateEnd":_vm.dateEnd}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }